import { Typography } from '@shipengine/giger';
import { useTranslation } from '@packlink/translation-provider';
import { jsxs, jsx } from '@emotion/react/jsx-runtime';

function TrackingParcelCount(_ref) {
  let {
    parcels,
    ...otherProps
  } = _ref;
  const parcelCount = parcels.length;
  const {
    t
  } = useTranslation();
  return jsxs("div", {
    ...otherProps,
    children: [jsx(Typography, {
      variant: "subtitle2",
      bold: true,
      component: "div",
      children: t('tracking-details.titles.parcel-label', {
        count: parcelCount
      })
    }), jsx(Typography, {
      variant: "small",
      component: "div",
      children: t('tracking-details.parcel.parcel-count-label', {
        count: parcelCount
      })
    })]
  });
}

export { TrackingParcelCount };
//# sourceMappingURL=TrackingParcelCount.js.map
